import React from 'react';

import styled from 'styled-components';

import { ComingSoonStat } from 'types/comingSoonFeatures';

import { MutedText, Row, Source } from './ComingSoonStyles';

const Stat = styled.div`
  padding-left: 20px;
  border-left: 2px solid var(--flamingo-pink);
`;

const StatValue = styled.div`
  font-size: 60px;
  line-height: 1;

  span {
    font-size: 28px;
    color: var(--flamingo-pink);
  }
`;

const StatTitle = styled.div`
  margin: 10px 0;
  font-family: var(--font-bold);
  text-transform: uppercase;
`;

type Props = {
  stats: ComingSoonStat[];
};

const ComingSoonStats = ({ stats }: Props) => (
  <Row>
    {stats.map((stat) => (
      <Stat key={stat.title}>
        <StatValue>
          {stat.value}
          <span>{stat.unit}</span>
        </StatValue>
        <StatTitle>{stat.title}</StatTitle>
        <MutedText>{stat.text}</MutedText>
        <Source>{stat.source}</Source>
      </Stat>
    ))}
  </Row>
);

export default ComingSoonStats;
